import initNavigation from '@/components/navigation';

document.addEventListener('DOMContentLoaded', () => {
  initNavigation();
});
